{
    "LicenseManagement_Title": "Gestion des licences d'entreprise",
    "LicenseManagement_Heading_License": "Licence - Équipes",
    "LicenseManagement_Heading_Quantity": "Quantité",
    "LicenseManagement_Essentials": "L'essentiel",
    "LicenseManagement_Essentials_MST": "Norme CXA",
    "LicenseManagement_Professional": "Professionnel",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Entreprise",
    "LicenseManagement_Enterprise_MST": "CXA Avancé (Historique)",
    "LicenseManagement_CallCentreAgent": "Agent du centre d'appel",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreSupervisor": "Superviseur du centre d'appels",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA Avancé",
    "LicenseManagement_Validation_Number": "Doit être un nombre valide",
    "LicenseManagement_Validation_Limit": "Dépasse le plafond de la licence de FMC. Doit être inférieur ou égal à {}",
    "LicenseManagement_Validation_Limit_Reached": "Dépasse le plafond des licences de CME. Il n'y a plus de licences disponibles",
    "LicenseManagement_Validation_MAX_LIMIT": "Le nombre dépasse le nombre maximum autorisé",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Le nombre doit être positif",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "Intégration CX"
}